exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.alertCon {\n  width: 90%;\n}\n", "", {"version":3,"sources":["/home/ZCIPClient/workpath/160391/code/5g-message-h5/src/clientEntry/index.vue","/home/ZCIPClient/workpath/160391/code/5g-message-h5/src/clientEntry/index.vue"],"names":[],"mappings":";AA+CA;EACE,WAAA;CC9CD","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.alertCon{\n  width: 90%;\n}\n",".alertCon {\n  width: 90%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e7150a1","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/clientEntry/index.vue
// module id = Pz59
// module chunks = 1